import * as React from 'react'
import Link from 'next/link'
import { FormattedMessage, useIntl } from 'react-intl'
import { List, ListItem, Header, Content, Main, Headline } from 'components/page'
import Head from 'components/Head'
import { Page } from 'layouts/pages'
import Weather from 'clients/weather'
import * as StationsUtils from '@avcan/utils/products/weather/stations'
import { path } from 'utils/station'

export async function getStaticProps() {
    const stations = await Weather.stations()
    const sections = StationsUtils.createSections(stations)

    return {
        props: {
            sections: Array.from(sections),
        },
    }
}

export default function WeatherStationList({ sections }) {
    const title = (
        <FormattedMessage
            description="Layout weather/station/WeatherStationList"
            defaultMessage="Weather stations"
        />
    )
    const intl = useIntl()
    const pageTitle = intl.formatMessage({
        description: 'Weather Stations',
        defaultMessage: 'Weather Stations',
    })

    return (
        <Page>
            <Head title={pageTitle} description={pageTitle} />
            <Header title={title} />
            <Content>
                <Main>
                    <Headline>
                        <FormattedMessage
                            description="Layout weather/station/WeatherStationList"
                            defaultMessage="Click on a link below to see weather
                                    station data."
                        />
                    </Headline>
                    {sections.map(([source, stations]) => (
                        <section key={source}>
                            <h2>{source}</h2>
                            <List data={stations} renderItem={renderItem} />
                        </section>
                    ))}
                </Main>
            </Content>
        </Page>
    )
}

// Utils
function renderItem({ stationId, name }) {
    return (
        <ListItem key={stationId}>
            <Link href={path(stationId)}>
                <a>{name}</a>
            </Link>
        </ListItem>
    )
}
